import { Link } from 'gatsby';
import type { FC } from 'react';
import type { FAQSection } from '../../../@types/gql/home';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import Accordion from '../../shared/accordion';

const HomeFAQsSection: FC<FAQSection> = ({ Title, faqs }) => {
 
  return (
    <section className="bg-white py-14">
      <div className="container mx-auto px-6">
        <div className="gap-14 justify-between">
          <div className="max-w-6xl">
            <h6 className="text-4xl font-bold pb-6 max-lg:text-2xl">{Title}</h6>
            <div className="flex flex-col gap-1.5">
              {faqs?.map(({ Answer, Question, id }, idx) => (
                <OpacitySlideIn
                  delay={Math.min(idx * 0.01 + 0.1, 1)}
                  key={id}
                  slideFrom={{ x: -20, y: 0 }}
                >
                  <Accordion
                    defaultOpen={idx === 0}
                    slNo={`${idx + 1}`}
                    title={Question}
                  >
                    <p className="font-light">{Answer}</p>
                  </Accordion>
                </OpacitySlideIn>
              ))}
              <div className="flex mt-2">
                <Link
                  className="font-bold bg-action-btn2 py-3.5 my-5 text-white px-4 space-x-2 text-base uppercase
                      transition-smooth hover:scale-105 hover:-translate-y-1 hover:shadow-lg w-fit rounded-lg max-lg:text-sm"
                  to="/faqs"
                >
                  View all Questions
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQsSection;
